import Joi from '@hapi/joi'

export const EmployeeTaskDetailReportschemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    registrationNumber: Joi.number().invalid(0).label("Registration Number").messages({
        "any.invalid": `Select Registration Number`,
        "any.required": `Registration Number required`
    }),
    toDate: Joi.string().invalid("").required().label("To Date"),
    fromDate: Joi.string().invalid("").required().label("From Date")
    
    

    
}

